import Carousel from "./BlogsCarousel";
import Location from "./components/locationComponent/Location";
import ParaGraphSection from "./components/ParagraphSection/ParaGraphSection";
import SingleBlogHeroSection from "./components/SingleBlogHeroSection/SingleBlogHeroSection";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import { useParams } from "react-router-dom";
import { blogArray } from "../../blog";
import { useEffect, useState } from "react";
import "./singleBlogs.style.css";
import PageForCities from "../PagesForCities/PageForCities";
import slugify from 'slugify';

const SingleBlogPage = () => {
  const { slug } = useParams(); // Get the slug from the URL

  // Simulate fetching the blog post by its slug
  const blog = blogArray.find(
    (b) => slugify(b.title, { lower: true, strict: true }) === slug
  );

  // console.log(blog);
  if (!blog) {
    return <p>Blog not found</p>;
  }

  // const { id } = useParams();
  // useEffect(() => {
  //   // Convert the 'id' to a number if it's a numeric value

  //   // Filter and find the blog with the matching ID
  //   const filteredBlog = blogArray.find((blog) => blog.id === +id);

  //   if (filteredBlog) {
  //     setSingleBlog(filteredBlog); // Store the filtered blog in the state
  //   }
  // }, [id]); // This useEffect will re-run when 'id' changes
  // // Handling the case where no blog is found
  // if (!singleBlog) {
  //   return <div>Blog not found!</div>;
  // }

  return (
    <div>
      {/* <div className="section">
        <SingleBlogHeroSection />
        <Location />
      </div> */}
      {blog.blog_type === "city" ? (
        <PageForCities blog={blog}/>
      ) : (
        <>
          <div className="mt-20">
            <ParaGraphSection singleBlog={blog} />
            <Carousel blogArray={blogArray} />
          </div>
          <div className="relative top-28  left-0 right-0">
            <HelpCard />
          </div>
        </>
      )}
    </div>
  );
};

export default SingleBlogPage;
